import SlaCompliance from "./slaCompliance.component";

export default SlaCompliance;
